import * as React from 'react';
import type { IChipsOption } from '@cian/ui-kit';
import { IconActionChevronDown16 } from '@cian/ui-kit-design-tokens/icons';

import { TFilterSelector } from '../../../types/filterSelectors';
import { getChipDataTestId } from '../utils';

export const useChips = (chips: TFilterSelector[]) => {
  const options = React.useMemo<IChipsOption<number>[]>(() => {
    return chips.map((item, index) => {
      return {
        value: index,
        label: item.name,
        dataTestId: getChipDataTestId(item.isActive),
        ref: React.createRef<HTMLLIElement>(),
        icon:
          'dialog' in item ? (
            <IconActionChevronDown16 color="icon-main-default" data-testid="DialogChipButtonIcon" />
          ) : null,
      };
    });
  }, [chips]);

  const value = React.useMemo(() => {
    return chips.reduce<number[]>((acc, item, index) => {
      if (item.isActive) {
        acc.push(index);
      }

      return acc;
    }, []);
  }, [chips]);

  return {
    options,
    value,
  };
};
